import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import SupplierContext from "../../../../contexts/SupplierContext";
import logo from "../../../../assets/images/stripe/stripe-logo.svg";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import UserContext from "../../../../contexts/UserContext";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import INotification from "../../../../models/INotification";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    isMainViewLight: boolean;
};

export const StripeConnect: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [publishableApiKey, setPublishableApiKey] = useState<string | undefined | null>(
        supplierModel.Supplier_Integration.stripe_publishable_api_key
    );
    const [secretApiKey, setSecretApiKey] = useState<string | undefined>();

    useEffect(() => {
        props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, onUpdateSupplierIntegrations);

        return () => {
            props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, onUpdateSupplierIntegrations);
        };
    }, []);

    useEffect(() => {
        setPublishableApiKey(supplierModel.Supplier_Integration.stripe_publishable_api_key);
    }, [supplierModel.Supplier_Integration.stripe_publishable_api_key]);

    const toggleStripe = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_stripe: !supplierModel.Supplier_Integration.has_stripe,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const onUpdateSupplierIntegrations = () => {};

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "stripe_secret_api_key":
                setSecretApiKey(value);
                break;

            case "stripe_publishable_api_key":
                setPublishableApiKey(value);
                break;
        }
    };

    const saveUpdate = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                stripe_publishable_api_key: publishableApiKey,
            },
        };

        if (secretApiKey?.length) {
            payload.Supplier_Integration.stripe_secret_api_key = secretApiKey;
        }

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    return (
        <div className={"StripeConnect"}>
            <OwAccordion
                hideChevron={!supplierModel.Supplier_Integration.has_stripe}
                leftImage={logo}
                leftImageHeight={30}
                titleClick={supplierModel.Supplier_Integration.has_stripe}
                rightElem={
                    <div className={"ms-auto"}>
                        <OwToggle
                            active={!!supplierModel.Supplier_Integration.has_stripe}
                            name={"toggleStripe"}
                            fn={toggleStripe}
                            label={""}
                            showDisableConfirm={true}
                        />
                    </div>
                }>
                <div>
                    <div>
                        <OwLabel title={"publishable_api_key"} />
                        <OwFnInput fn={handleChange} name={"stripe_publishable_api_key"} value={publishableApiKey} />
                    </div>

                    <div className={"mt-2"}>
                        <OwLabel title={"secret_api_key"} />
                        <OwFnInput fn={handleChange} name={"stripe_secret_api_key"} value={secretApiKey} />
                    </div>

                    <div className={"mt-2"}>
                        <OwButton title={"save"} fn={saveUpdate} />
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
